<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col v-for="(item, indice) in listado" :key="indice" cols="12" md="4" lg="3" class="pa-0">
            <ListadoItem :nombreCampo="item.nombre" :valorCampo="item.valor" />
          </v-col>

          <v-col cols="12">
            <template v-if="permisosAcademicosNacional">
              <v-btn
                class="mx-1"
                color="primary"
                title="Agregar Estudiantes"
                small
                :disabled="
                  [
                    estadosProgramasUniversidades.INSCRITO,
                    estadosProgramasUniversidades.NO_EJECUTADO_DISPONIBLE,
                  ].includes(form.estado)
                "
                @click="$refs.ModalFormularioInscripcionesRef.abrir(accionesCrud.REGISTRAR, [])">
                <v-icon>mdi-plus</v-icon>

                Agregar Estudiantes
              </v-btn>

              <v-btn
                small
                class="mx-1"
                :disabled="
                  item == null ||
                  (getFiltrarPorSede && item.inscripcion.programa.sedeId != $store?.state?.cargo_sede?.sede?.id) ||
                  form.estado === estadosProgramasUniversidades.INSCRITO
                "
                title="Eliminar"
                @click="
                  () =>
                    confirmacionAccion(
                      accionesAConfirmar.ELIMINAR,
                      nombreItem,
                      `de ${item.inscripcion.estudiante.nombres} ${item.inscripcion.estudiante.primerApellido} ${item.inscripcion.estudiante.segundoApellido}`,
                    )
                ">
                <v-icon>mdi-close</v-icon>

                Eliminar
              </v-btn>

              <v-btn
                class="mx-1"
                title="Establecer Códigos Empastados"
                small
                :disabled="form.estado !== estadosProgramasUniversidades.INSCRITO"
                @click="confirmarEstablecimientoCodigosEmpastados">
                <v-icon>mdi-barcode-scan</v-icon>

                Establecer Códigos Empastados
              </v-btn>
            </template>

            <v-btn class="mx-1" title="Recargar" small @click="listar">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>

            <v-btn
              class="mx-1"
              title="Ver PDF"
              small
              :disabled="cargandoPdf"
              :loading="cargandoPdf"
              @click="obtenerReporteInscripcionProgramaUniversidad">
              <v-icon>mdi-file-pdf</v-icon>

              Ver PDF
            </v-btn>

            <v-btn
              class="mx-1"
              title="Descargar Excel"
              small
              :disabled="descargandoExcel"
              :loading="descargandoExcel"
              @click="obtenerExcelInscripcionProgramaUniversidad">
              <v-icon>mdi-file-excel</v-icon>

              Descargar Excel
            </v-btn>
          </v-col>

          <v-col cols="12">
            <ListadoInscripcionProgramaUniversidad
              ref="listadoRef"
              :items="items"
              :cargando="cargando"
              @selectItem="selectItem" />
          </v-col>
        </v-row>

        <ModalFormularioInscripciones
          ref="ModalFormularioInscripcionesRef"
          :nombreRecurso="nombreItem"
          :programaUniversidadId="form.id"
          :itemsYaSeleccionados="items"
          :universidadId="form.sedeUniversidad?.universidadId"
          @actualizarListado="listar" />

        <ConfirmacionAccion
          ref="confirmacionRef"
          :titulo="confirmacion.titulo"
          :mensaje="confirmacion.mensaje"
          :realizandoAccion="confirmacion.realizandoAccion"
          @aceptar="confirmacion.fnAceptar" />

        <ModalVerPdf ref="modalVerPdfRef" />
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ListadoInscripcionProgramaUniversidad from './ListadoInscripcionProgramaUniversidad.vue';
import InscripcionProgramaUniversidadService from '../services/inscripcion-programa-universidad.service';
import ModalFormularioInscripciones from './ModalFormularioInscripciones.vue';
import { mapGetters } from 'vuex';
import programaUniversidadMixin from '../mixins/programa-universidad.mixin';
import ModalVerPdf from './ModalVerPdf.vue';
import InscripcionProgramaUniversidadReporteService from '../services/inscripcion-programa-universidad-reporte.service';
import { ESTADOS_PROGRAMAS_UNIVERSIDADES } from '../utils/constantes';
import InscripcionProgramaUniversidadExcelService from '../services/inscripcion-programa-universidad-excel.service';
import programaUniversidadService from '../services/programa-universidad.service';
import { concatenar } from '../utils/funciones';

export default {
  name: 'ModalInscripcionesProgramaUniversidad',
  mixins: [programaUniversidadMixin],
  components: {
    ListadoInscripcionProgramaUniversidad,
    ModalFormularioInscripciones,
    ModalVerPdf,
  },
  data() {
    return {
      nombreItem: 'Inscripción',
      cargandoPdf: false,
      descargandoExcel: false,
      estadosProgramasUniversidades: ESTADOS_PROGRAMAS_UNIVERSIDADES,
    };
  },
  computed: {
    ...mapGetters('pago', ['getFiltrarPorSede', 'permisosAcademicosNacional']),
  },
  methods: {
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
      this.listar();
    },
    listar() {
      const params = {
        programaUniversidadId: this.form.id,
      };

      this.obtenerDatosConNotificacion(InscripcionProgramaUniversidadService.findAll, 'items', this.nombreItem, params);

      this.item = null;
    },
    async getResponseAccion(accion) {
      let response = null;

      if (accion === this.accionesAConfirmar.ELIMINAR) {
        response = await InscripcionProgramaUniversidadService.remove(this.item.id, {
          realizadoPorId: this.$store.state.DATA_USER.id,
          realizadoPor: concatenar(
            this.$store.state.DATA_USER.nombres,
            this.$store.state.DATA_USER.pri_apellido,
            this.$store.state.DATA_USER.seg_apellido,
          ),
        });
      }

      return response;
    },
    async obtenerReporteInscripcionProgramaUniversidad() {
      const params = {
        formato: 'base64',
      };

      this.cargandoPdf = true;

      try {
        const { data } = await InscripcionProgramaUniversidadReporteService.findPorProgramaUniversidadId(this.form.id, {
          params,
        });
        const { datos, mensaje } = data;
        const base64 = datos;
        const pdf = `data:application/pdf;base64,${base64}`;

        this.$refs.modalVerPdfRef.abrir(pdf);
        this.$notify({
          group: 'notifications',
          title: this.nombreItem,
          text: mensaje || 'Listado exitoso',
          type: 'success',
        });
      } catch (error) {
        const { mensaje } = error?.response?.data;

        window.console.log(error);

        this.base64 = [];
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al obtener el reporte',
          type: 'error',
        });
      } finally {
        this.cargandoPdf = false;
      }
    },
    async obtenerExcelInscripcionProgramaUniversidad() {
      this.descargandoExcel = true;

      try {
        const { data } = await InscripcionProgramaUniversidadExcelService.findPorProgramaUniversidadId(this.form.id);
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        const nombreExcel = `${this.form.codigo}_${this.form.programaNombre}`.toUpperCase().split(' ').join('_');

        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', nombreExcel);
        document.body.appendChild(link);
        link.click();

        this.$notify({
          group: 'notifications',
          title: this.nombreItem,
          text: 'Descarga exitosa',
          type: 'success',
        });
      } catch (error) {
        window.console.log(error);

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Error al descargar el archivo',
          type: 'error',
        });
      } finally {
        this.descargandoExcel = false;
      }
    },
    confirmarEstablecimientoCodigosEmpastados() {
      this.confirmacion.titulo = 'Establecer Códigos Empastados';
      this.confirmacion.mensaje = '¿Está seguro de establecer los códigos empastados?';
      this.confirmacion.fnAceptar = this.establecerCodigosEmpastados;
      this.$refs.confirmacionRef.abrir();
    },
    async establecerCodigosEmpastados() {
      this.confirmacion.realizandoAccion = true;

      try {
        const { data } = await programaUniversidadService.establecerCodigosEmpastados(this.form.id);
        const { mensaje } = data;

        this.listar();
        this.$refs.confirmacionRef.cerrar();
        this.$notify({
          group: 'notifications',
          title: this.nombreItem,
          text: mensaje || 'Establecimiento exitoso',
          type: 'success',
        });
      } catch (error) {
        const { mensaje } = error?.response?.data;

        window.console.log(error);

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al establecer los códigos empastados',
          type: 'error',
        });
      } finally {
        this.confirmacion.realizandoAccion = false;
      }
    },
  },
};
</script>